import React, {useEffect} from "react";
import {IQuestion} from "../../../data/interfaces/IQuestion";
import "./style.scss";


export function SliderQuestionComponent(props: {
    question: IQuestion,
    onChange: (node: IQuestion) => void;
}) {

    const {question, onChange} = props;

    const change = () => {
        question.isValid = !(question.selectedValue === undefined);
        onChange(question);
    }

    useEffect(() => {
        if(question.selectedValue === undefined) {
            question.selectedValue = question.defaultValue ?? question.min;
            change();
        }
    }, []);

    return (
        <div className="survey-form-section">
            {
                (question.text !== undefined) && (
                    <label htmlFor="name" className="survey-form-section-label">
                        {question.text}
                    </label>
                )
            }

            <div className="survey-form-section-content">

                <label className="survey-form-slider-container">
                    <input className="survey-form-slider-input"
                        type="range"
                        min={question.min}
                        max={question.max}
                        value={(question.selectedValue ?? question.min)}
                        step={1}
                        onChange={(event) => {
                            question.selectedValue = Number(event.target.value);
                            change();
                        }}
                    />
                    <span>{(question.selectedValue ?? question.min)}</span>
                </label>

            </div>

        </div>
    )
}